<template>
  <div
    v-if="isShowComponent"
    class="datasheet-button-container"
  >
    <a
      class="datasheet-button text-muted"
      :href="parsedUrl"
      target="_blank"
    >
      <i
        class="fa fa-file-pdf-o"
        aria-hidden="true"
      />
      <span>{{ $translate("EnergyLabel::Template.energyLabelDatasheet") }}</span>
    </a>
  </div>
</template>

<script>
import { elParseTemplatedExpression } from '../helper/parser';

export default {

  inject: {
    itemId: {
      default: null
    }
  },
  props: {
    itemData: [String, Object]
  },

  computed: {
    computedItemData () {
      if (this.itemData === 'singleItem') {
        return this.$store.getters[`${this.itemId}/currentItemVariation`];
      }
      return this.itemData;
    },

    isUseLowercase () {
      if (EnergyLabelConfig.global.useLowercase === true || EnergyLabelConfig.global.useLowercase == 'true') {
        return true;
      }
      return false;
    },

    parsedUrl () {
      const datasheetUrl = EnergyLabelConfig.global.datasheet ? EnergyLabelConfig.global.datasheet : '';

      return this.parseTemplatedExpression(datasheetUrl, true);
    },

    isShowComponent () {
      return this.parsedUrl && this.parsedUrl.length > 0;
    }
  },

  methods: {
    parseTemplatedExpression (text, emptyWipe = false) {
      return elParseTemplatedExpression(text, this.computedItemData, this.isUseLowercase, emptyWipe);
    }
  }

};
</script>
